export default "__VITE_ASSET__de6394e0__"